import React from 'react';
import { WebsiteDesignProps } from './types';
import { Heart, Users, Calendar, ArrowRight, Smile } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CommunityHub: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Unity High";

    return (
        <div className="bg-orange-50 text-slate-800 font-sans min-h-screen">
             <header className="bg-white py-4 px-6 border-b border-orange-100 sticky top-0 z-50">
                 <div className="container mx-auto flex justify-between items-center">
                     <div className="flex items-center gap-2 font-bold text-xl text-orange-600">
                         <Users size={24} /> {schoolName}
                     </div>
                     <div className="hidden md:flex gap-4">
                         <Button variant="ghost" className="text-slate-600 hover:text-orange-600">Events</Button>
                         <Button variant="ghost" className="text-slate-600 hover:text-orange-600">Staff</Button>
                         <Button variant="ghost" className="text-slate-600 hover:text-orange-600">Parents</Button>
                         <Button className="bg-orange-500 hover:bg-orange-600 text-white">Join Us</Button>
                     </div>
                 </div>
             </header>

             <section className="py-20 container mx-auto px-6 text-center">
                 <div className="flex justify-center mb-6">
                     <div className="bg-orange-100 text-orange-600 px-4 py-2 rounded-full flex items-center gap-2 font-bold text-sm">
                         <Heart size={16} fill="currentColor" /> The Heart of the Community
                     </div>
                 </div>
                 <h1 className="text-4xl md:text-6xl font-bold mb-6 text-slate-900 leading-tight">
                     Better Together. <br/> Learning For Everyone.
                 </h1>
                 <p className="text-xl text-slate-600 mb-12 max-w-2xl mx-auto">
                     We are more than just a school. We are a family of learners, educators, and neighbours working towards a brighter future.
                 </p>

                 {/* Grid of Faces */}
                 <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
                     {[
                         "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop",
                         "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1974&auto=format&fit=crop",
                         "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1976&auto=format&fit=crop",
                         "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?q=80&w=2070&auto=format&fit=crop"
                     ].map((img, i) => (
                         <div key={i} className="aspect-square rounded-2xl overflow-hidden shadow-md hover:scale-105 transition-transform">
                             <img src={img} className="w-full h-full object-cover" alt="Student" />
                         </div>
                     ))}
                 </div>
             </section>

             <section className="bg-white py-16">
                 <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12">
                     <div className="bg-orange-600 rounded-3xl p-10 text-white flex flex-col justify-between">
                         <div>
                             <h3 className="text-2xl font-bold mb-4">Latest Newsletter</h3>
                             <p className="opacity-90">Read about our recent charity drive and the upcoming sports day.</p>
                         </div>
                         <div className="mt-8 flex items-center gap-2 font-bold cursor-pointer hover:opacity-80">
                             Read Issue #42 <ArrowRight />
                         </div>
                     </div>
                     <div className="bg-blue-600 rounded-3xl p-10 text-white flex flex-col justify-between">
                         <div>
                             <h3 className="text-2xl font-bold mb-4 flex items-center gap-2"><Calendar /> Upcoming Event</h3>
                             <p className="text-3xl font-bold mt-2">Family Fun Fair</p>
                             <p className="opacity-90">Saturday, 24th August</p>
                         </div>
                         <Button className="bg-white text-blue-600 hover:bg-blue-50 w-fit mt-8 font-bold">Register Now</Button>
                     </div>
                 </div>
             </section>
        </div>
    );
};

export default CommunityHub;
